import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
import * as yup from "yup"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Members';
moduleConfig.singleItemTitle = 'Member';
moduleConfig.url = 'members';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Block Selected",
        value: "Block"
    },
    {
        displayName: "Unblock Selected",
        value: "Unblock"
    }
];


export default moduleConfig;